import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import { Typography, CardContent, Card, Button, Grid } from "@material-ui/core";
import * as StudentSapApi from "../../../../src/api/student/sap/StudentSapApi";
import { useSelector } from "react-redux";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import NotificationModal from "../../../components/_Layout/Modal/NotificationModal";
import AccessManager from "../../../components/security/AccessManager";
import { security } from "../../../constants/Security/securityConstants";
import { MTFDetailPopup } from "./MTFDetailPopup";
import InfoIcon from "@material-ui/icons/Info";
import { CreditMTFDetailPopup } from "./CreditMtfDetailPopup";
import { relative } from "path";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      width: "100%",
    },
    header: {
      height: "40px",
      padding: "10px",
      fontWeight: 600,
      width: "100%",
      backgroundColor: theme.palette.secondary.dark,
    },
    cardTitle: {
      fontSize: 17,
      color: "Black",
      textDecoration: "bold",
      backgroundColor: theme.palette.secondary.dark,
      padding: theme.spacing(1, 1),
    },
    headerText: {
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(0),
    },
    cardSeparator: {
      marginBottom: theme.spacing(1),
    },
    button: {
      padding: theme.spacing(1),
      margin: theme.spacing(2, 0),
    },
    buttonColorPrimary: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
      textDecoration: "bold",
      padding: theme.spacing(1),
      whiteSpace: "nowrap",
      margin: theme.spacing(2, 0),
    },
  })
);

function ResultTitleIVSAP() {
  const classes = useStyles();
  const [faCheckResultsId, setFACheckResultsId] = React.useState<string>("");
  const [notificationPopupState, setNotificationPopupState] =
    React.useState<any>({
      id: "notification-popup",
      message: "",
    });
  const [TitleIVData, setTitleIVData] = React.useState([] as any);
  const [selected, setSelected] = React.useState([] as any);
  const [isCreditHour, setIsCreditHour] = React.useState(false);
  const isSelected = (fasapCheckResultsId: any) =>
    selected.indexOf(fasapCheckResultsId) !== -1;

  const selectAllClick = (event: any) => {
    if (event.target.checked) {
      const selected = TitleIVData.map((n: any) => n.fasapCheckResultsId);
      setSelected(selected);
      return;
    }
    setSelected([]);
  };
  const rowClick = (event: any, resultId: string) => {
    const selectedIndex = selected.indexOf(resultId);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, resultId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const student = useSelector((state: any) => state.student);

  React.useEffect(() => {
    if (student.selectedEnrollment && student.selectedEnrollment.stuEnrollId) {
      let enrollmentId = student.selectedEnrollment.stuEnrollId;
      loadTitleIVResults(student.studentId, enrollmentId);
      setIsCreditHour(student?.selectedEnrollment?.isCreditHour);
    }
  }, [student.selectedEnrollment]);

  const updateStudentOnTitleIVProbation = () => {
    if (faCheckResultsId != "") {
      StudentSapApi.PlaceStudentOnTitleIVProbation(faCheckResultsId).then(
        (response: any) => {
          if (response && response.data == true) {
            if (
              student.selectedEnrollment &&
              student.selectedEnrollment.stuEnrollId
            ) {
              let enrollmentId = student.selectedEnrollment.stuEnrollId;
              loadTitleIVResults(student.studentId, enrollmentId);
            }
          } else {
            setNotificationPopupState((state: any) => {
              return {
                ...state,
                open: true,
                notificationText:
                  "Student is not eligible for TitleIV probation",
                notificationButton: "Ok",
                showCancelButton: false,
                title: "Place Student on Probation",
                onConfirmEvent: () => {
                  setNotificationPopupState((updatedState: any) => {
                    return { ...updatedState, open: false };
                  });
                },
              };
            });
          }
        },
        (exception: any) => {}
      );
      setAnchorEl(null);
    }
  };

  const loadTitleIVResults = (studentId: string, enrollmentId: string) => {
    StudentSapApi.getTitleIVResultsForStudent(studentId, enrollmentId).then(
      (response: any) => {
        if (response) {
          setTitleIVData(response.data);
        }
      },
      (exception: any) => {}
    );
  };

  const doPrint = () => {
    if (selected.length > 0) {
      let params = {
        StudentEnrollmentId: student.selectedEnrollment.stuEnrollId,
        CheckResultIdList: selected,
        StudentName: student.studentName,
      };
      StudentSapApi.printTitleIVResults(params).then(
        (response: any) => {},
        (exception: any) => {}
      );
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: any, fasapCheckResultsId: string) => {
    setFACheckResultsId(fasapCheckResultsId);
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: any) => {
    setFACheckResultsId("");
    setAnchorEl(null);
  };

  const [mtfDetailIdForPopup, setMtfDetailIdForPopup] =
    React.useState<string>("");
  const openMtfPopUp = (mtfDetailId: string) => {
    setMtfDetailIdForPopup(mtfDetailId);
  };

  return (
    <Card className={classes.cardSeparator}>
      <Typography className={clsx(classes.cardTitle)}>
        <div className={classes.headerText}>Results</div>
      </Typography>
      <CardContent>
        <TableContainer component={Paper} style={{ width: "100%" }}>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="center" colSpan={1}>
                  Print
                </TableCell>
                <TableCell align="center" colSpan={5}>
                  Quantitative
                </TableCell>
                <TableCell align="center" colSpan={3}>
                  Qualitative
                </TableCell>
                <TableCell align="center" colSpan={3}>
                  Maximum Time Frame
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  Result
                </TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell align="center">
                  <Checkbox
                    value="uncontrolled"
                    color="primary"
                    onClick={selectAllClick}
                    inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                  />
                </TableCell>
                <TableCell>
                  {isCreditHour ? "Credits Attempted" : "Hours"}
                </TableCell>
                <TableCell align="right">
                  {isCreditHour ? "Credits Earned" : "Scheduled"}
                </TableCell>

                <TableCell align="right"> {isCreditHour ? "Actual Pace%" : "Actual"}</TableCell>
                
                <TableCell align="right">{isCreditHour ? "Required Pace%" : "Required"}</TableCell>
              
                <TableCell align="right">Satisfied</TableCell>
                <TableCell align="right">
                  {isCreditHour ? "GPA" : "Grade"}
                </TableCell>
                <TableCell align="right">Required</TableCell>
                <TableCell align="right">Satisfied</TableCell>
                <TableCell align="right">Student MTF</TableCell>
                <TableCell align="right">Program MTF</TableCell>
                <TableCell align="right">Satisfied</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {TitleIVData.map((row: any) => {
                const isRowSelected = isSelected(row.fasapCheckResultsId);
                const QuantSatisfied =
                  row.percentCompleted >= row.quantitativeRequired
                    ? "Yes"
                    : "No";
                const QualSatisfied =
                  row.grade >= row.qualitativeRequired ? "Yes" : "No";
                return (
                  <TableRow
                    key={row.fasapCheckResultsId}
                    onClick={(event) =>
                      rowClick(event, row.fasapCheckResultsId)
                    }
                    role="checkbox"
                    selected={isRowSelected}
                  >
                    <TableCell align="center">
                      <Checkbox
                        value="uncontrolled"
                        color="primary"
                        inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                        checked={isRowSelected}
                      />
                      {!!row.mtfDetail && !isCreditHour && (
                        <MTFDetailPopup
                          open={
                            row.mtfDetail.mtfDetailId == mtfDetailIdForPopup &&
                            !!row.mtfDetail
                          }
                          mtfDetail={row.mtfDetail}
                          handleClose={() => {
                            setMtfDetailIdForPopup("");
                          }}
                        />
                      )}
                      {!!row.creditMtfDetail && isCreditHour && (
                        <CreditMTFDetailPopup
                          open={
                            row.creditMtfDetail.mtfDetailId ==
                              mtfDetailIdForPopup && !!row.creditMtfDetail
                          }
                          creditMtfDetail={row.creditMtfDetail}
                          handleClose={() => {
                            setMtfDetailIdForPopup("");
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {isCreditHour ? row.creditAttempted : row.hoursEarned}
                    </TableCell>
                    <TableCell align="center">
                      {isCreditHour ? row.creditEarned : row.hoursScheduled}
                    </TableCell>
                    <TableCell align="center">
                      {row.performQuantitative == true
                        ? row.percentCompleted
                        : ""}
                    </TableCell>
                    <TableCell align="center">
                      {row.performQuantitative == true
                        ? row.quantitativeRequired
                        : ""}
                    </TableCell>
                    <TableCell align="center">
                      {row.performQuantitative == true ? QuantSatisfied : ""}
                    </TableCell>
                    <TableCell align="center">
                      {parseFloat(row.grade).toFixed(2)}
                    </TableCell>
                    <TableCell align="center">
                      {row.qualitativeRequired}
                    </TableCell>
                    <TableCell align="center">{QualSatisfied}</TableCell>

                    {!isCreditHour && (
                      <TableCell align="center">
                        {!!row.mtfDetail ? row.enrollmentActualMTFWeeks : ""}
                      </TableCell>
                    )}
                    {isCreditHour && (
                      <TableCell align="center">
                        {!!row.creditMtfDetail
                          ? row.creditMtfDetail?.studentMtf ?? ""
                          : ""}
                      </TableCell>
                    )}
                    {!isCreditHour && (
                      <TableCell align="center">
                        {!!row.mtfDetail ? row.programMTFWeeks : ""}
                      </TableCell>
                    )}
                    {isCreditHour && (
                      <TableCell align="center">
                        {!!row.creditMtfDetail
                          ? row.creditMtfDetail?.programMtf ?? ""
                          : ""}
                      </TableCell>
                    )}
                    <TableCell align="center" style={{ cursor: "pointer" }}>
                      <Grid container>
                        <Grid item md={6} spacing={2}>
                          {!isCreditHour && (
                            <Typography>
                              {!!row.mtfDetail
                                ? row.isMTFSatisfied == true
                                  ? "Yes"
                                  : "No"
                                : ""}
                            </Typography>
                          )}
                          {isCreditHour && (
                            <Typography>
                              {!!row.creditMtfDetail
                                ? row.creditMtfDetail.isSatisfied == true
                                  ? "Yes"
                                  : "No"
                                : ""}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item md={6}>
                          {((!isCreditHour && !!row.mtfDetail) ||
                            (isCreditHour && !!row.creditMtfDetail)) && (
                            <InfoIcon
                              onClick={() => {
                                openMtfPopUp(
                                  !isCreditHour
                                    ? row.mtfDetail.mtfDetailId
                                    : row.creditMtfDetail.mtfDetailId
                                );
                              }}
                              fontSize={"small"}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell align="center">{row.sapStatus}</TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="more"
                        aria-controls={"probation-menu"}
                        disabled={
                          row.sapStatusCode == "Ineligible" ? false : true
                        }
                        aria-haspopup="true"
                        onClick={(e: any) => {
                          handleClick(e, row.fasapCheckResultsId);
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Menu
          id={"probation-menu"}
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: "25ch",
            },
          }}
        >
          {
            <MenuItem
              onClick={(v: any) => {
                updateStudentOnTitleIVProbation();
              }}
            >
              Place Student on Probation
            </MenuItem>
          }
        </Menu>
        <AccessManager
          allowedPermissions={[
            security.permissions.reports.printTitleIVSAPNotices,
          ]}
          renderNoAccess={() => (
            <Button
              disabled={true}
              onClick={() => {
                doPrint();
              }}
              className={classes.button}
              size="small"
              type="button"
              color="primary"
            >
              Print
            </Button>
          )}
        >
          <Button
            className={classes.buttonColorPrimary}
            onClick={() => {
              doPrint();
            }}
            size="small"
            type="button"
          >
            Print
          </Button>
        </AccessManager>
      </CardContent>
      <NotificationModal {...notificationPopupState} />
    </Card>
  );
}
export default ResultTitleIVSAP;
